module.exports = __webpack_public_path__ + "media/images/vp/icon.yt.white-c5ef39e9ec6f484d91372a7547b986fc.png";